module.exports = __webpack_public_path__ + "assets/img/img5-a77a4769.png";